import controller from "emun.cart/multi-cart/multi-cart.controller";
import shoppingConfig from "emun.shopping/shopping.config";

//templates
import views from "emun.cart/multi-cart/multi-cart.views";

//styles
import "emun.cart/multi-cart/multi-cart.scss";

export default shoppingConfig.multiCart
  ? {
      controller,
      bindings: {
        layout: "@",
        orderStatus: "@",
        ngModel: "=?",
        multiCartId: "<?",
        submittedCartIds: "<?",
        remaining: "<?",
      },
      templateUrl($element, $attrs) {
        return (
          $attrs.templateUrl ||
          views[$attrs.layout || $attrs.view || $attrs.type] ||
          views.main
        );
      },
    }
  : { template: "<div></div>" };
